import axios from 'axios';
import * as http from '@/api/cifra-client';
import { useCifraClient } from '@/api/cifra-client';

const URL_BASE = '/lomloe/competencias_especificas';
const { cifraClient } = useCifraClient();

export default {
  guardar(definicion) {
    return http.createOrUpdate(
      cifraClient,
      URL_BASE,
      definicion,
      { namespace: 'definicion' },
    );
  },
  eliminar(definicion, options) {
    const data = { definicion };
    return axios.delete(`${URL_BASE}/${definicion.id}`, { data }, options);
  },
  guardarOrden(idsItems, options) {
    return axios.post(`${URL_BASE}/guardar_orden`, { orden: idsItems }, options);
  },
  getVariablesParaFormula(idCompetenciaEspecifica, options) {
    return axios.get(
      `${URL_BASE}/${idCompetenciaEspecifica}/variables_para_formula`,
      {},
      options,
    );
  },
  importarFichero(idCurso, definicion, file) {
    const formData = new FormData();
    formData.append('curso_id', idCurso);
    formData.append('tipo_nota_id', definicion.tipo_nota_id);
    if (definicion.conversion_id) {
      formData.append('conversion_id', definicion.conversion_id);
    }
    if (definicion.con_observaciones) {
      formData.append('con_observaciones', definicion.con_observaciones);
    }
    formData.append('fichero', file);
    return axios.post(`${URL_BASE}/importar_fichero`, formData);
  },
};
